import { Input, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'earn-reward-card',
  templateUrl: './earn-reward-card.component.html',
  styleUrls: ['./earn-reward-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EarnRewardCardComponent implements OnInit {


  @Input() earnTitle : string = "You'll Earn";
  @Input() earnValue : number;
  @Input() purchaseType : string;
  @Input() earnPercent: string;
  @Input() nights: number;
  @Input() earnPercentLabel: string;
  @Input() showPerDay: boolean = true;
  @Input() savingsPercent: number;
  public get earnValuePerNight(): number{
    if(!isNaN(this.nights) && this.nights!=0){
      return Math.round(this.earnValue / this.nights)
    }
  }

  public get showEarnPercent(): boolean{
    if(this.earnPercent!=undefined){
      if(this.savingsPercent!=undefined){
        let parsedEarnPercent: number = Number.parseFloat(this.earnPercent);
        return (!Number.isNaN(parsedEarnPercent) && parsedEarnPercent > this.savingsPercent);
      }
      return true;
    }

    return false;
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/earn-reward-card/earn-reward-card.component.ts